import { Typography } from "@mui/material";
import moment from "moment";
import { Link } from "react-router-dom";

import { TMyClass, TSummary } from "../../../../../@types";
import { lessonType } from "../../../../../constants";

export type TSummaryItemProps = {
	summary: TSummary;
};

export function SummaryItem({ summary }: TSummaryItemProps) {
	const totalLessons = summary.bookings.length;
	let totalPassedLessons = 0;
	let nextLesson: TMyClass | undefined = undefined;
	let airHours = 0;
	let simulatorHours = 0;
	let milesFlown = 0;

	for (let i = 0; i < totalLessons; i++) {
		const booking = summary.bookings[i];
		airHours += booking.airHours;
		simulatorHours += booking.simulatorHours;
		milesFlown += booking.milesFlown;

		if (
			booking.lesson.type === lessonType.ONSITE &&
			new Date() > new Date(booking.endTime ?? "")
		) {
			totalPassedLessons++;
			continue;
		}

		if (booking.lesson.type === lessonType.ONLINE && booking.passed) {
			totalPassedLessons++;
			continue;
		}

		if (!nextLesson) {
			nextLesson = booking;
		}
	}

	let link = `/learning/${summary.course.courseSlug}`;
	if (nextLesson) {
		link = `/learning/${summary.course.courseSlug}?class=${nextLesson.id}`;
	}

	let progressText = "";
	if (totalPassedLessons === 1) {
		progressText = `1 class out of ${totalLessons}`;
	} else {
		progressText = `${totalPassedLessons} classes out of ${totalLessons}`;
	}
	const airHoursText = `${airHours.toFixed(1)} hrs in Flight`;
	const simulatorHoursText = `${simulatorHours.toFixed(1)} hrs in Sim`;
	const milesFlownText = `${milesFlown} miles Flown`;

	return (
		<>
			<div className="summary-item-container item-separator-small">
				<div style={{ display: "flex", alignItems: "center", gap: "32px" }}>
					<Typography className="big-text bold" flex={1}>
						{summary.course.name}
					</Typography>
					{totalPassedLessons === totalLessons && (
						<div className="summary-information-container">
							<Typography className="normal-text success-text bold">
								FINISHED
							</Typography>
						</div>
					)}
				</div>
				<div className="separator" />
				<div
					className="item-separator-small"
					style={{ display: "flex", flexDirection: "column", rowGap: "8px" }}>
					{totalPassedLessons < totalLessons && nextLesson && (
						<div className="summary-information-container">
							<Typography className="normal-text">
								<span className="bold">Next Class:</span>
								{` ${nextLesson.lesson.title}`}
							</Typography>
							{nextLesson.startTime && (
								<Typography className="normal-text">
									<span className="bold">Appointment Date:</span>
									{` ${moment(nextLesson.startTime).format("dddd, D MMM YYYY, HH:mm")}`}
								</Typography>
							)}
						</div>
					)}
					<Typography className="normal-text bold">Progress:</Typography>
					<div className="summary-information-container">
						<Typography className="normal-text">{progressText}</Typography>
						<Typography className="normal-text">{airHoursText}</Typography>
						<Typography className="normal-text">
							{simulatorHoursText}
						</Typography>
						<Typography className="normal-text">{milesFlownText}</Typography>
					</div>
					<Link to={link} className="blue-text underline-link">
						<Typography className="normal-text bold">Course Binder</Typography>
					</Link>
				</div>
			</div>
		</>
	);
}
